export const HOME_TRACKING_SOURCE = 'home';
